import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useDoubleClick } from '../hooks/index';
import { useAccordionContext } from './AccordionContext';
const styles = {
    container: css({
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
    }),
    item: (isOpen) => {
        return css([
            {
                display: 'flex',
                flexDirection: 'column',
            },
            isOpen && { flex: '1 1 0%' },
        ]);
    },
    header: css({
        cursor: 'pointer',
        padding: '5px 12px',
        display: 'flex',
        alignItems: 'center',
        fontSize: '1em',
        borderColor: 'rgb(213, 213, 213) currentcolor currentcolor',
        borderStyle: 'solid none none',
        color: 'rgb(45, 45, 45)',
        fontWeight: 'bold',
        textDecoration: 'none',
        textShadow: 'rgb(255, 255, 255) 0px 1px 0px',
        background: 'rgb(255, 255, 255) linear-gradient(rgb(240, 240, 240) 5%, rgb(225, 225, 225) 100%) repeat scroll 0% 0%',
    }),
};
export function Accordion(props) {
    return _jsx("div", { css: styles.container, children: props.children });
}
Accordion.Item = function AccordionItem(props) {
    const { item, utils } = useAccordionContext(props.title, props.defaultOpened);
    const onClickHandle = useDoubleClick({
        onClick: utils.toggle,
        onDoubleClick: utils.clear,
    });
    let displayable = false;
    if (item) {
        displayable = item.isOpen;
    }
    return (_jsxs("div", { style: {
            flex: displayable ? '1 1 1px' : 'none',
            display: 'flex',
            flexDirection: 'column',
        }, children: [_jsx("button", { onClick: onClickHandle, type: "button", style: {
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    userSelect: 'text',
                }, css: styles.header, children: props.title }), _jsx("div", { style: {
                    display: displayable ? 'flex' : 'none',
                    flex: displayable ? '1 1 1px' : 'none',
                    backgroundColor: 'white',
                    maxHeight: '100%',
                    overflow: 'hidden',
                }, children: _jsx("div", { style: {
                        height: '100%',
                        width: '100%',
                        overflow: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                    }, children: props.children }) })] }));
};
//# sourceMappingURL=Accordion.js.map